import { postAdLog } from './postAdLog';
import { postLog } from './postLog';

export const logService = {
  postLog,
  postAdLog,
};
